import styled from 'styled-components';

export const AccentTextSection = styled.span`
  color: ${p => p.theme.brandPrimary};
`;
